import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const fetchAdminMerchantStats = async ({ token, merchantId, period }) => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/order/admin/merchants/${merchantId}/stats`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { period },
    }
  );
  return response.data.stats;
};

const useAdminMerchantStats = (merchantId, period = "month") => {
  const { token } = useContext(AuthContext);

  return useQuery(
    ["adminMerchantStats", merchantId, period],
    () => fetchAdminMerchantStats({ token, merchantId, period }),
    { enabled: !!token && !!merchantId }
  );
};

export default useAdminMerchantStats;
